import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setBeefFeedAdditive, setBeefFeedAdditiveAdmin } from "services";

import { footprintingBeefPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_BEEF_FEED_ADDITIVE } from "consts";

import { UploadableBeefFeedAdditive } from "models";

export const useMutateFootprintingBeefFeedAdditive = (primaryDataId: string, farmId: string, year: number) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useMutation<UploadableBeefFeedAdditive[], Error, UploadableBeefFeedAdditive[]>({
    mutationKey: [FOOTPRINTING_BEEF_FEED_ADDITIVE, primaryDataId, isAdmin],
    mutationFn: (data) => (isAdmin ? setBeefFeedAdditiveAdmin(primaryDataId, data) : setBeefFeedAdditive(primaryDataId, data)),
    onSuccess: () => {
      invalidateAndRefecthQueries(queryClient, [
        [FOOTPRINTING_BEEF_FEED_ADDITIVE, primaryDataId, isAdmin],
        ...footprintingBeefPrimaryQueryKeys(primaryDataId, farmId, year, isAdmin),
      ]);
    },
  });
};
